import { ECurrency } from '../../types/enums'
import { getCurrencyFractionDigits } from '.'

export const transformMoneyIntegerToFloat = (
  amountInMinorUnits: number | bigint,
  currency: ECurrency = ECurrency.USDT,
  maxDecimals?: number,
) => {
  const currencyFractionDigits = getCurrencyFractionDigits(currency)
  const amountNumber =
    typeof amountInMinorUnits === 'bigint'
      ? Number(amountInMinorUnits) / 10 ** currencyFractionDigits
      : amountInMinorUnits / 10 ** currencyFractionDigits

  return Number(
    amountNumber.toFixed(
      maxDecimals
        ? Math.min(currencyFractionDigits, maxDecimals)
        : currencyFractionDigits,
    ),
  )
}
